module.exports = __webpack_public_path__ + "img/apple-icon.a0e37115.svg";